import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { PriceContainer as PriceFilterContainer, PriceTypeContainer } from './containers';
import { selectPriceTypeAvailable } from 'shared/selectors/filters';
import { useSelector } from 'react-redux';

export const PriceContainer: FC = () => {
  const isPriceTypeAvailable = useSelector(selectPriceTypeAvailable);

  return (
    <AdvancedFilterRow label="Цена">
      <InlineFilterGroup>
        <InlineFilter width={232}>
          <PriceFilterContainer />
        </InlineFilter>
        {isPriceTypeAvailable && (
          <InlineFilter>
            <PriceTypeContainer />
          </InlineFilter>
        )}
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
